import Vue from 'vue'
import { round } from 'utils/common'

// 设置期货利率
Vue.filter('setInterest', num => {
  if (isNaN(num)) return '--'
  const interestArr = [
    '000',
    '002',
    '005',
    '007',
    '010',
    '012',
    '015',
    '017',
    '020',
    '022',
    '025',
    '027',
    '030',
    '032',
    '035',
    '037',
    '040',
    '042',
    '045',
    '047',
    '050',
    '052',
    '055',
    '057',
    '060',
    '062',
    '065',
    '067',
    '070',
    '072',
    '075',
    '077',
    '080',
    '082',
    '085',
    '087',
    '090',
    '092',
    '095',
    '097',
    '100',
    '102',
    '105',
    '107',
    '110',
    '112',
    '115',
    '117',
    '120',
    '122',
    '125',
    '127',
    '130',
    '132',
    '135',
    '137',
    '140',
    '142',
    '145',
    '147',
    '150',
    '152',
    '155',
    '157',
    '160',
    '162',
    '165',
    '167',
    '170',
    '172',
    '175',
    '177',
    '180',
    '182',
    '185',
    '187',
    '190',
    '192',
    '195',
    '197',
    '200',
    '202',
    '205',
    '207',
    '210',
    '212',
    '215',
    '217',
    '220',
    '222',
    '225',
    '227',
    '230',
    '232',
    '235',
    '237',
    '240',
    '242',
    '245',
    '247',
    '250',
    '252',
    '255',
    '257',
    '260',
    '262',
    '265',
    '267',
    '270',
    '272',
    '275',
    '277',
    '280',
    '282',
    '285',
    '287',
    '290',
    '292',
    '295',
    '297',
    '300',
    '302',
    '305',
    '307',
    '310',
    '312',
    '315',
    '317'
  ]
  const interestPartArr = [
    '0.0000000',
    '0.0078125',
    '0.0156250',
    '0.0234375',
    '0.0312500',
    '0.0390625',
    '0.0468750',
    '0.0546875',
    '0.0625000',
    '0.0703125',
    '0.0781250',
    '0.0859375',
    '0.0937500',
    '0.1015625',
    '0.1093750',
    '0.1171875',
    '0.1250000',
    '0.1328125',
    '0.1406250',
    '0.1484375',
    '0.1562500',
    '0.1640625',
    '0.1718750',
    '0.1796875',
    '0.1875000',
    '0.1953125',
    '0.2031250',
    '0.2109375',
    '0.2187500',
    '0.2265625',
    '0.2343750',
    '0.2421875',
    '0.2500000',
    '0.2578125',
    '0.2656250',
    '0.2734375',
    '0.2812500',
    '0.2890625',
    '0.2968750',
    '0.3046875',
    '0.3125000',
    '0.3203125',
    '0.3281250',
    '0.3359375',
    '0.3437500',
    '0.3515625',
    '0.3593750',
    '0.3671875',
    '0.3750000',
    '0.3828125',
    '0.3906250',
    '0.3984375',
    '0.4062500',
    '0.4140625',
    '0.4218750',
    '0.4296875',
    '0.4375000',
    '0.4453125',
    '0.4531250',
    '0.4609375',
    '0.4687500',
    '0.4765625',
    '0.4843750',
    '0.4921875',
    '0.5000000',
    '0.5078125',
    '0.5156250',
    '0.5234375',
    '0.5312500',
    '0.5390625',
    '0.5468750',
    '0.5546875',
    '0.5625000',
    '0.5703125',
    '0.5781250',
    '0.5859375',
    '0.5937500',
    '0.6015625',
    '0.6093750',
    '0.6171875',
    '0.6250000',
    '0.6328125',
    '0.6406250',
    '0.6484375',
    '0.6562500',
    '0.6640625',
    '0.6718750',
    '0.6796875',
    '0.6875000',
    '0.6953125',
    '0.7031250',
    '0.7109375',
    '0.7187500',
    '0.7265625',
    '0.7343750',
    '0.7421875',
    '0.7500000',
    '0.7578125',
    '0.7656250',
    '0.7734375',
    '0.7812500',
    '0.7890625',
    '0.7968750',
    '0.8046875',
    '0.8125000',
    '0.8203125',
    '0.8281250',
    '0.8359375',
    '0.8437500',
    '0.8515625',
    '0.8593750',
    '0.8671875',
    '0.8750000',
    '0.8828125',
    '0.8906250',
    '0.8984375',
    '0.9062500',
    '0.9140625',
    '0.9218750',
    '0.9296875',
    '0.9375000',
    '0.9453125',
    '0.9531250',
    '0.9609375',
    '0.9687500',
    '0.9765625',
    '0.9843750',
    '0.9921875'
  ]
  const numStr = num.toString()
  const intNum = numStr.split('.')[0]
  const floatNum = (numStr.replace(intNum, '0') - 0).toFixed(7)
  const inArr = interestPartArr.indexOf(floatNum)
  let formatFloat = 0
  if (inArr < 0) {
    formatFloat = round(Math.ceil(Number(floatNum * 3200)) / 10).toString()
  } else {
    formatFloat = interestArr[inArr].toString()
  }
  if (formatFloat.length < 3) {
    formatFloat = (formatFloat + '00').substring(0, 3)
  }
  return `${intNum}'${formatFloat}`
})
